module.exports = __webpack_public_path__ + "img/entertainment-dark-5.76bf5b1c.jpg";